const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/credits/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermission } from '@/common/hooks/usePermissions';
export const Route = createFileRoute('/(app)/org/$org/settings/credits')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ctx => {
    await requirePermission('view_billing')(ctx);
    if (!ctx.context.flags.platformCreditUsage) {
      throw redirect({
        to: '/org/$org/settings',
        params: {
          org: ctx.params.org
        }
      });
    }
  }
});